export enum Modules {
  RegistrationApproval,
  PaymentVerification,
  LoanModuleApproval,
  LoanCommitteeApproval1,
  LoanCommitteeApproval2,
}

export enum SanjeevaniModules {
  ModuleApproval,
  // ModuleReject,
}
